import React, { useEffect, useState, useContext } from "react";
import { dias, masDias, diaMes, colorActividad, clBasic, bkSubMain } from "./general";
import ListaAsignados from "./ListaAsignados";
import ListaAdjuntos from "./ListaAdjuntos";
import { AppContext } from "./index";
import { Actividad, Usuario } from "./contexto/ClasesGrales";
import MenuActividad from "./MenuActividad"
import ListaStories from "./ListaStories"

export default function CanvaActividad({ ind, lmax, setRefresh, setTrash, ampliado, setChange }) {
  let { firebase } = useContext(AppContext);
  let actividades = firebase.proyectoActivo.actividades;

  const hmax = "42";
  const [xDown, setXdown] = useState(0); // fija la X en donde se presiono el boton del mouse, para saber en que direc. ir
  const [down, setDown] = useState(false); // marca si esta presionado el boton del mouse
  const [fecha, setFecha] = useState(null); // ini o fin para indicar cual fecha es la que se esta cambiando
  const [xAnt, setXant] = useState(0); // para controlar la velocidad del cursor

  // carga del contexto del canvas que muestra la barra de actividad
  useEffect(() => {
    let { maxDias, fmenor } = firebase.marcoFechas(actividades);
    let xini = (dias(actividades[ind].inicio, fmenor) * lmax) / maxDias;
    let xfin = (dias(actividades[ind].finEstimado, fmenor) * lmax) / maxDias;
    let c = document.getElementById(`CCcanvas${actividades[ind].id}`);
    let ctx = c.getContext("2d");
    ctx.clearRect(0, 0, lmax, hmax);
    ctx.fillStyle = actividades[ind].color;
    barraTiempo(ctx, xini, 12, xfin - xini, 16);
    ctx.font = down === true ? "12px  Arial" : "10px Arial";
    ctx.fillStyle = clBasic;
    ctx.fillText(diaMes(actividades[ind].finEstimado), xfin - ctx.measureText(diaMes(actividades[ind].finEstimado)).width, 9);
    ctx.fillStyle = clBasic;
    ctx.fillText(diaMes(actividades[ind].inicio), xini, 38);
    // mostrar progreso
    ctx.fillStyle = "black";
    ctx.fillRect(xini, 18, ((xfin - xini) * actividades[ind].progreso) / 100, 4);
  });

  function barraTiempo(context, x, y, w, h) {
    let r = h / 2;
    context.beginPath();
    context.moveTo(x + r, y);
    context.lineTo(x + w - r, y);
    context.arc(x + w - r, y + h / 2, r, (Math.PI / 2) * 3, Math.PI / 2);
    context.lineTo(x + r, y + h);
    context.arc(x + r, y + h / 2, r, Math.PI / 2, (Math.PI / 2) * 3);
    context.closePath();
    context.fill();
  }

  function markDown(e) {
    e.preventDefault();
    setXdown(e.clientX - e.target.getClientRects()[0].left);

    let { maxDias, fmenor } = firebase.marcoFechas(actividades);
    let xini = (dias(actividades[ind].inicio, fmenor) * lmax) / maxDias;
    let xfin = (dias(actividades[ind].finEstimado, fmenor) * lmax) / maxDias;
    if (Math.abs(e.clientX - e.target.getClientRects()[0].left - xini) < Math.abs(xfin - e.clientX + e.target.getClientRects()[0].left))
      setFecha("ini");
    else setFecha("fin");
    setDown(true);
  }

  function markUp(e) {
    setDown(false);
  }

  function markMove(e) {
    let dif = Math.abs(xAnt - (e.clientX - e.target.getClientRects()[0].left));
    if (dif > 2) setXant(e.clientX - e.target.getClientRects()[0].left); //  control de velocidad del cambio de coordenada

    if (down && dif > 2) {
      if (e.clientX - e.target.getClientRects()[0].left >= 0 && e.clientX - e.target.getClientRects()[0].left < lmax)
        if (e.clientY - e.target.getClientRects()[0].top >= 0 && e.clientY - e.target.getClientRects()[0].top < 30) {
          if (e.clientX - e.target.getClientRects()[0].left > xDown)
            if (fecha === "fin") actividades[ind].finEstimado = masDias(actividades[ind].finEstimado, 1);
            else
              actividades[ind].inicio =
                dias(actividades[ind].finEstimado, actividades[ind].inicio) > 5
                  ? masDias(actividades[ind].inicio, 1)
                  : actividades[ind].inicio;
          else if (fecha === "fin")
            actividades[ind].finEstimado =
              dias(actividades[ind].finEstimado, actividades[ind].inicio) > 5
                ? masDias(actividades[ind].finEstimado, -1)
                : actividades[ind].finEstimado;
          else actividades[ind].inicio = masDias(actividades[ind].inicio, -1);
        }
      setRefresh((r) => !r);
      setChange(true)
    }
  }

  function allowDrop(e) {
    e.preventDefault();
  }

  function drop(e) {
    e.preventDefault();
    e.target.style.border = ""
    let data = JSON.parse(e.dataTransfer.getData("text"));
    if (data.obj === "usuario") {
      // es un usuario
      let u = new Usuario();
      u.inicializarConRegistroDB(data.usuario);
      if (!actividades[ind].usuarioAsignado(u.id)) {
        actividades[ind].asignados = [...actividades[ind].asignados, u];
      } else {
        alert("Usuario ya asignado a la actividad");
      }
      setTrash(false);
      setRefresh((r) => !r);
      setChange(true)
      return;
    }

    if (data.obj === "tarea") {
      let indDest = ind; // aqui ind es el de la tarea en la que se hace el drop, por eso es el mismo que viene en props
      let ini = data.ind;
      let fin = indDest;
      let step = data.ind <= indDest ? 1 : -1;
      let actAux = actividades[data.ind];
      for (let x = ini; x !== fin; x += step) {
        actividades[x] = actividades[x + step];
      }
      actividades[indDest] = actAux;
      setTrash(false);
      setRefresh((r) => !r);
      setChange(true)
      return;
    }

    if (data.obj === "story") {
      // es una historia de usuario
      actividades[ind].stories = [...actividades[ind].stories, data.historia];
      firebase.asignarSprint(data.historia, actividades[ind].id, "...en uso...")

      setRefresh((r) => !r);
      setChange(true)
      return;
    }
  }

  function drag(e, ind) {
    let data = { obj: "tarea", ind: ind }; // guardo el indice de la actividad a mover
    e.dataTransfer.setData("text", JSON.stringify(data));
    e.target.cursor = "move";
    setTrash(true);
    setRefresh((r) => !r);
  }

  function nuevaLinea(e, ind) {
    if (ind === actividades.length - 1) {
      if (e.keyCode === 9) {
        //  presiono Tab y es la ultima. Deberia controlar que escriba algo antes pero bueno...
        let numAct = firebase.proyectoActivo.numeroActividad();
        actividades.push(
          new Actividad(
            "",
            "ACT" + "000".slice(numAct.toString().length) + numAct.toString(),
            "",
            actividades[ind].finEstimado,
            masDias(actividades[ind].finEstimado, 30),
            "",
            0,
            0,
            0,
            colorActividad[ind % colorActividad.length],
            [],
            [],
            0,
            [])
        );
        setChange(true);
        setRefresh((r) => !r);
      }
    }
  }

  return (
    <div style={SmarcoActividad}>
      <div style={Sactividad} id={`actividad${actividades[ind].id}`}>
        <input
          style={Snombre}
          type="text"
          defaultValue={actividades[ind].nombre}
          onKeyDown={(e) => nuevaLinea(e, ind)}
          onChange={(e) => { actividades[ind].nombre = e.target.value; setChange(true) }}
          onDragEnter={(e) => e.target.disabled = true}
          onDragLeave={(e) => e.target.disabled = false}
          title={actividades[ind].nombre}
        />
        <div style={ScanvasDrag} draggable="true" onDragStart={(e) => drag(e, ind)}
          onDrop={(e) => drop(e)} onDragOver={(e) => allowDrop(e)}
          onDragEnter={(e) => e.target.style.border = "dashed 2px #424242"}
          onDragLeave={(e) => e.target.style.border = ""}>
          <div style={ScanvaAct}>
            <canvas
              id={`CCcanvas${actividades[ind].id}`}
              height={hmax}
              width={lmax}
              onMouseDown={(e) => markDown(e)}
              onMouseUp={(e) => markUp(e)}
              onMouseOver={(e) => markUp(e)}
              onMouseMove={(e) => markMove(e)}
            ></canvas>
          </div>
        </div>

        <div
          id={`asignados${actividades[ind].id}`}
          style={Sasignados}
          onClick={() => {
            actividades[ind].shiftAsignados();
            setRefresh((r) => !r);
          }}
          draggable="true"
          onDragOver={(e) => allowDrop(e)}
          onDrop={(e) => drop(e)}
        >
          <ListaAsignados asignados={actividades[ind].asignados} ind={ind} setRefresh={setRefresh} setTrash={setTrash} />
        </div>
        {ampliado && (
          <select style={Sprogreso} defaultValue={actividades[ind].progreso} onChange={(e) => { actividades[ind].progreso = e.target.value; setChange(true) }}>
            <option value={0} >
              0%
          </option>
            <option value={25} >
              25%
          </option>
            <option value={50} >
              50%
          </option>
            <option value={75} >
              75%
          </option>
            <option value={100} >
              100%
          </option>
          </select>
        )}
        {ampliado && (
          <input style={Shoras} defaultValue={actividades[ind].horas} onChange={(e) => { actividades[ind].horas = e.target.value; setChange(true) }} />
        )}
        {(firebase.proyectoActivo.proyecto.tipo === "Agil") && (
          <input style={Spuntos} value={actividades[ind].puntos} disabled={true} />
        )}
        <div
          id={`adjuntos${actividades[ind].id}`}
          style={Sadjuntos}
          onClick={() => {
            actividades[ind].shiftAdjuntos();
            setRefresh((r) => !r);
          }}
        >
          <ListaAdjuntos adjuntos={actividades[ind].files} ind={ind} setRefresh={setChange} setTrash={setTrash} />
        </div>
        <MenuActividad elemento={`actividad${actividades[ind].id}`} ind={ind} setRefresh={setRefresh} setChange={setChange} />
      </div>
      { actividades[ind].stories.length !== 0 && <ListaStories historias={actividades[ind].stories} />}
    </div >
  );
}

//
//  styles para cada division
//
const SmarcoActividad = {
  position: "relative",
  margin: "7px 4px 4px 0px",
  borderBottom: "dotted thin #212121",
}

const Sactividad = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
};

const ScanvasDrag = {
  cursor: "move",
};

const ScanvaAct = {
  marginTop: "5px",
  marginBottom: "5px",
  cursor: "pointer",
};

const Snombre = {
  border: `solid 2px ${bkSubMain}`,
  margin: "7px 12px 7px 0px",
  width: "12vw",
  background: "black",//"#EFFBEF",
  fontSize: "1.8vh",
  padding: "0px 10px 0px 10px",
  borderRadius: "10px",
  color: "white", //clBasic,
};

const Sasignados = {
  position: "relative",
  width: "4vw",
  marginLeft: "10px",
};

const Sprogreso = {
  border: `solid 2px ${clBasic}`,
  margin: "7px 7px 7px 0px",
  width: "4.3vw",
  background: "transparent",
  fontSize: "1.8vh",
  borderRadius: "5px",
  alignText: "center",
  color: clBasic,
};

const Sadjuntos = {
  position: "relative",
  width: "4vw",
  marginLeft: "5px",
};

const Shoras = {
  border: `solid 2px ${clBasic}`,
  margin: "7px 7px 7px 7px",
  width: "2.7vw",
  background: "transparent",
  fontSize: "1.8vh",
  borderRadius: "5px",
  alignText: "center",
  color: clBasic,
};

const Spuntos = {
  border: `solid 2px ${clBasic}`,
  margin: "7px 7px 7px 7px",
  width: "2.7vw",
  background: "transparent",
  fontSize: "1.8vh",
  borderRadius: "5px",
  alignText: "center",
  color: clBasic,
};
